import { Field } from 'redux-form';
import InfoInput from './InfoInput';

const InfoField = (props) => {
  return (
    <div>
      <Field
        {...props}
        component={InfoInput}
      />
    </div>
  );
};

export default InfoField;
